<template>
    <main-content with_go_back_bar>
        <kt-panel v-if="catMembersStatus === 'success' && findGroupStatus === 'success'">
            <kt-panel-body >
                <form class="kt-form" @submit.prevent="update" >
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="6" md="6" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="group_name">
                                        {{ $t('label.group_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="rtl"
                                        type="group_name"
                                        name="group_name"
                                        id="group_name"
                                        v-model="groupData.group_name"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="user_ids">
                                        {{ $t('label.user') }}
                                    </kt-form-label>
                                    <select
                                        id="user_ids"
                                        name="user_ids"
                                        class="form-control kt-selectpicker"
                                        v-model="groupData.user_ids"
                                        multiple
                                    >
                                        <option
                                            v-bind:key="index"
                                            v-for="(user, index) in categorizedUsers"
                                            :selected="isSelectedUser(user.id)"
                                            :value="user.id"
                                        >
                                            {{ user.full_name }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>

                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {userService} from "@/common/api.service";
import Vue from "vue";
import {KTUtil} from "@/plugins/core/util";
import {mapGetters} from "vuex";
import {i18n} from "@/plugins/i18n";

export default {
    components: {
        MainContent
    },
    data() {
        return {
            query: {},
            cat_id: this.$route.params.cat_id
        }
    },
    mounted() {
        this.afterMounted()
    },
    computed: {
        ...mapGetters('user', [
            'groupData',
            'catMembersStatus',
            'findGroupStatus',
            'categorizedUsers',
        ])
    },
    methods: {
        afterMounted() {
            if (this.catMembersStatus !== 'success') {
                this.$store.dispatch('user/fetchCategoryMembers', this.cat_id)
            }
            this.$store.dispatch('user/fetchGroup', this.$route.params.hashid).finally(() => {
                this.runSelectPicker()
            })
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        update(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    group_name : {
                        required: true,
                    }
                },
            });

            if(!form.valid()) {
                return
            }

            let params = {
                group_name: this.groupData.group_name,
                user_id: this.groupData.user_ids,
            }

            KTApp.progress(btn)
            userService.updateGroup(params, this.$route.params.hashid)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        isSelectedUser(hashidd) {
            return Object.values(this.groupData.user_ids).includes(hashidd)
        }
    }
}
</script>